import { createRootRouteWithContext, Outlet, useNavigate } from '@tanstack/react-router';
import { AppLayout } from '@/features/navigation/components/app-layout/AppLayout';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { AppRouterContext } from '@/lib/router.tsx';
import { SidebarManager } from '@/common/components/sidebar-manager/SidebarManager.tsx';
import { ErrorDisplay } from '@/common/components/error-display/ErrorDisplay.tsx';
import { Trans } from '@lingui/react/macro';
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';
import { ModalProvider } from '@/common/components/modal-provider/ModalProvider';

const NotFoundComponent = () => {
  const navigate = useNavigate();
  return (
    <ErrorDisplay
      title={<Trans>Page not found</Trans>}
      message={<Trans>The page you are looking for does not exist.</Trans>}
      actions={
        <Button variant="contained" startIcon={<HomeIcon />} onClick={() => navigate({ to: '/' })}>
          <Trans>Homepage</Trans>
        </Button>
      }
    />
  );
};

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: () => (
    <>
      <ModalProvider>
        <SidebarManager>
          <AppLayout>
            <Outlet />
          </AppLayout>
        </SidebarManager>
      </ModalProvider>
      <TanStackDevtools
        config={{
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'TanStack Query',
            render: <ReactQueryDevtoolsPanel />,
          },
          {
            name: 'TanStack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          formDevtoolsPlugin(),
        ]}
      />
    </>
  ),
  notFoundComponent: NotFoundComponent,
});
